import Vue from "vue"
import VueRouter from "vue-router"
import Home from "../views/Home.vue"

// 解决产生了冗余导航，vue-router报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}


Vue.use(VueRouter)
// 文化活动
const activity = {
  path: "activity",
  name: "activity",
  redirect: '/home/activity/mainpage',
  component: () => import('@/views/activity'),
  children: [
    {
      path: "mainpage",
      name: "ActivityList",
      component: () => import('@/views/activity/components/list'),
    },
    {
      path: "detail",
      name: "ActivityDetail",
      component: () => import('@/views/activity/components/detail'),
    },
  ]
}
// 新闻
const news = {
  path: "news",
  name: "news",
  redirect: '/home/news/mainpage',
  component: () => import('@/views/news'),
  children: [
    {
      path: "mainpage",
      name: "NewsList",
      component: () => import('@/views/news/components/list'),
    },
    {
      path: "detail",
      name: "NewsDetail",
      component: () => import('@/views/news/components/detail'),
    },
  ]
}
// 相册
const album = {
  path: "album",
  name: "album",
  redirect: '/home/album/mainpage',
  component: () => import('@/views/album'),
  children: [
    {
      path: "mainpage",
      name: "AlbumList",
      component: () => import('@/views/album/components/list'),
    },
    {
      path: "detail",
      name: "AlbumDetail",
      component: () => import('@/views/album/components/detail'),
    },
  ]
}
// 直播
const live = {
  path: "live",
  name: "Live",
  redirect: '/home/live/mainpage',
  component: () => import('@/views/live'),
  children: [
    {
      path: "mainpage",
      name: "LiveList",
      component: () => import('@/views/live/components/list'),
    },
    {
      path: "detail",
      name: "LiveDetail",
      component: () => import('@/views/live/components/detail'),
    },
  ]
}
// 个人中心
const personalCenter = {
  path: "mine",
  name: "Personalcenter",
  redirect: '/home/mine/mainpage',
  component: () => import('@/views/mine'),
  children: [
    // 主页面
    {
      path: "mainpage",
      name: "PersonalcenterMainpage",
      component: () => import('@/views/mine/components/mainpage.vue'),
    },
  ]
}
const routes = [
  {
    path: "/", // 网站默认地址
    redirect: "/home" // 默认跳转首页，单独提出方便标明层级关系
  },
  {
    path: "/home",
    name: "Home",
    component: Home,
    redirect: '/home/index',
    children: [
      {
        path: "index",
        name: "Index",
        component: () => import('@/views/index'),
      },
      {
        path: "search",
        name: "Search",
        component: () => import('@/views/search'),
      },
      activity, // 文化活动
      news, // 新闻
      album, // 相册
      live, // 直播
      personalCenter,// 个人中心
    ]
  },
  // 登录
  {
    path: "/login",
    name: "Login",
    component: () => import('@/views/login'),

  },
  // 注册
  {
    path: "/register",
    name: "Register",
    component: () => import('@/views/login/register'),
  },
  // 找回密码
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: () => import('@/views/login/forgot-password'),
  },
  //直播登录
  {
    path: "/livelogin",
    name: "LiveLogin",
    component: () => import('@/views/livelogin'),
  },
  // 活动分享海报页（扫码直达，独立页面不含门户框架）
  {
    path: "/activity/share",
    name: "ActivitySharePoster",
    component: () => import('@/views/activity/share_poster'),
  },
  // 单点登录
  {
    path: "/sign_on",
    name: "sign_on",
    component: () => import('@/views/sign_on'),
  },
  {
    path: "/move",
    name: "LiveDetail",
    component: () => import('@/views/live/components/detail'),
  },
  // 排队
  {
    path: '/queue',
    name: 'Queue',
    component: () => import('@/views/error-page/queue')
  },
  // 已关闭
  {
    path: '/closed',
    name: 'Closed',
    component: () => import('@/views/error-page/closed')
  },
  // 风险拦截
  {
    path: '/risk',
    name: 'Risk',
    component: () => import('@/views/error-page/risk')
  },
  // 频繁请求
  {
    path: '/frequent',
    name: "Frequent",
    component: () => import('@/views/error-page/frequent'),
  },
]

const router = new VueRouter({
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return {
      x: 0,
      y: 0
    }
  }
})
router.beforeEach((to, from, next) => {
  if (to.path === from.path) {
    next(false) // 停止导航，防止重复路由
  } else {
    next() // 继续导航
  }
})
export default router
